import React, { useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Menu } from "primereact/menu";
import { Button } from "primereact/button";
import { Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";

const userData = JSON.parse(localStorage.getItem("user"));

const Header = () => {
  const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
      backgroundColor: "red",
      color: "red",
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      "&::after": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        animation: "ripple 1.2s infinite ease-in-out",
        border: "1px solid currentColor",
        content: '""',
      },
    },
    "@keyframes ripple": {
      "0%": {
        transform: "scale(.8)",
        opacity: 1,
      },
      "100%": {
        transform: "scale(2.4)",
        opacity: 0,
      },
    },
  }));

  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("user"));
  const navigateWithClear = (path) => {
    localStorage.removeItem("dashboardFilters");
    navigate(path);
  };
  const logout = () => {
    if (userData.isSuperAdmin) {
      localStorage.removeItem("user");
      localStorage.clear();
      navigateWithClear("/admin");
    } else if (userData.isAdmin) {
      localStorage.removeItem("user");
      localStorage.clear();
      navigateWithClear("/consultant");
    } else {
      localStorage.removeItem("user");
      localStorage.clear();
      navigateWithClear("/");
    }
  };
  const menu = useRef(null);
  const superAdminMenu = [
    {
      label: "Options",
      items: [
        {
          label: "Dashboard",
          icon: "pi pi-home",
          command: () => {
            navigateWithClear("/dashboard");
          },
        },

        {
          label: "Manage Consultants",
          icon: "pi pi-users",
          command: () => {
            navigateWithClear("/user-list");
          },
        },
        {
          label: "View users",
          icon: "pi pi-users",
          command: () => {
            navigateWithClear("/enduser-list");
          },
        },
        {
          label: "Register User",
          icon: "pi pi-user-plus",
          command: () => {
            navigateWithClear("/admin-user-signup");
          },
        },

        {
          label: "My Profile",
          icon: "pi pi-user",
          command: () => {
            navigateWithClear("/admin-profile");
          },
        },
        {
          label: "Logout",
          icon: "pi pi-sign-out",
          command: () => {
            logout();
          },
        },
      ],
    },
  ];

  const items = [
    {
      label: "Options",
      items: [
        {
          label: "Dashboard",
          icon: "pi pi-home",
          command: () => {
            navigateWithClear("/dashboard");
          },
        },
        {
          label: "Profile",
          icon: "pi pi-user",
          command: () => {
            userData.isAdmin
              ? navigateWithClear("/consultant-profile")
              : navigateWithClear("/user-profile");
          },
        },
        {
          label: "Logout",
          icon: "pi pi-sign-out",
          command: () => {
            logout();
          },
        },
      ],
    },
  ];

  const onHomepage = () => {
    window.location = "https://clearrmynotice.com/";
  };

  return (
    <>
      <header>
        <nav className="navbar navbar-expand-md navbar-light shadow-sm">
          <div className="container-fluid">
            <div className="headerAlign">
              <img
                src="/logotransparent.png"
                class="logoImage"
                style={{width : "200px", marginBottom : "20px"}}
                onClick={() => {
                  navigateWithClear("/dashboard");
                }}
              />
              {!userData && (
                <Button
                  className="homepageButton"
                  label="Homepage"
                  icon="pi pi-home"
                  onClick={onHomepage}
                />
              )}
            </div>
            <div>
              <ul className="navbar-nav d-flex align-items-center w-100 text-white">
                <li className="ml-sm-auto headerUsername">
                  {userData?.username && (
                    <Tooltip title={userData.username}>
                      <span
                        className="user-name"
                        style={{
                          marginRight: "10px",
                          fontSize: "larger",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "12ch",
                        }}
                      >
                        Welcome{" "}
                        {userData.username.length > 12
                          ? `${userData.username.slice(0, 12)}...`
                          : userData.username}{" "}
                        |
                      </span>
                    </Tooltip>
                  )}
                </li>
                <li className="ml-sm-auto" style={{ marginLeft: "10px" }}>
                  <Menu
                    model={userData.isSuperAdmin ? superAdminMenu : items}
                    popup
                    ref={menu}
                    id="popup_menu"
                  />
                  {userData.isProfileComplete ? (
                    <Button
                      icon="pi pi-bars"
                      onClick={(event) => menu.current.toggle(event)}
                      aria-controls="popup_menu"
                      aria-haspopup
                    />
                  ) : (
                    <Tooltip title={"Profile Details are not updated"}>
                    <StyledBadge
                      overlap="circular"
                      anchorOrigin={{ vertical: "top", horizontal: "right" }}
                      variant="dot"
                    >
                      <Button
                        icon="pi pi-bars"
                        onClick={(event) => menu.current.toggle(event)}
                        aria-controls="popup_menu"
                        aria-haspopup
                        className="button-with-badge"
                      ></Button>
                    </StyledBadge>
                    </Tooltip>
                  )
                  }
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Header;
